import student from './student'
import registrationRecord from './registrationRecord'
import createStudent from './createStudent'
import editStudent from './editStudent'
import buffet from './buffet'
import variable from './variable'
export default {
    variable,
    buffet,
    student,
    registrationRecord,
    createStudent,
    editStudent,
}